// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableV1_tableContainer__uP-98","table":"TableV1_table__4Nyz6"};